import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import { useLocation, useParams } from "react-router-dom";
import DownloadExcel, {
  formatDate,
  formatNumber,
  getRecords,
} from "../../../services/api.service";

const InstallationReport = () => {
  const { id } = useParams;
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [expandedCategories, setExpandedCategories] = useState({});
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [typeCostQTY, setTypeCostQTY] = useState(null);
  const location = useLocation();
  const selectedYear = location.state?.year;
  const recordsPerPage = 10;

  useEffect(() => {
    fetchReports();

    const handleStorageChange = () => {
      fetchReports();
    };

    window.addEventListener("dashboardUpdate", handleStorageChange);
    return () => {
      window.removeEventListener("dashboardUpdate", handleStorageChange);
    };
  }, []);

  const filteredItems =
    data.filter((row) =>
      row?.project_name?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredItems.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredItems.length / recordsPerPage);

  const fetchReports = async (Id) => {
    try {
      setLoadingData(true);
      const dashboard_details = localStorage.getItem("dashboard_details");
      if (!dashboard_details) return;

      const currentYear = new Date().getFullYear();
      const startDate = `${currentYear}-01-01`;
      const endDate = `${currentYear}-12-31`;

      const startOfYear = `${selectedYear}-01-01`;
      const endOfYear = `${selectedYear}-12-31`;

      const payload = {
        ...JSON.parse(dashboard_details),
        year: selectedYear ? selectedYear : currentYear,
        start_date: selectedYear ? startOfYear : startDate,
        end_date: selectedYear ? endOfYear : endDate,
      };
      setTypeCostQTY(payload.type);

      let responseData = await getRecords(
        payload,
        "/dashboard/installationReport"
      );
      if (responseData.data && responseData.data.length > 0) {
        setData(responseData.data || []);
        setLoadingData(false);
      } else {
        setData([]);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    setCurrentPage(1);
  };
  const toggleCategory = (index) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  const handleExportData = () => {
    const { columns, rows } = generateCSVData();

    DownloadExcel({
      fileName: "InstallationReport",
      columns: columns,
      data: rows,
      cellColor: false,
    });
  };

  const generateCSVData = () => {
    const columns = [
      { label: "Sr No", key: "srNo" },
      { label: "Project Name", key: "project_name" },
      { label: "Customer Name", key: "customer_name" },
      { label: "Installation No", key: "installation_no" },
      { label: "Date", key: "date" },
      {
        label: `Installed ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        key: "install_qty",
      },
      { label: "installation Claim", key: "installation_claim" },
      { label: "Installation Paid", key: "installation_paid" },
    ];

    const rows = [];

    filteredItems?.forEach((project, pIndex) => {
      if (pIndex !== 0) {
        rows.push({
          srNo: "",
          project_name: "",
          customer_name: "",
          installation_no: "",
          date: "",
          install_qty: "",
          installation_claim: "",
          installation_paid: "",
        });
      }
      rows.push({
        srNo: pIndex + 1,
        project_name: project?.project_name || "N/A",
        customer_name: project?.customer_name || "N/A",
        installation_no: project?.installation_no || "N/A",
        date: formatDate(project?.installation_date) || "N/A",
        install_qty:
          typeCostQTY == "cost"
            ? project.total_already_installed_cost
            : project.total_already_installed_qty || "0",
        installation_claim:
          typeCostQTY == "cost"
            ? project.total_installation_claim_cost
            : project.total_installation_claim || "0",
        installation_paid:
          typeCostQTY == "cost"
            ? project.total_installation_paid_cost
            : project?.total_installation_paid || "0",
      });

      rows.push({
        srNo: "",
        project_name: "Sr No",
        customer_name: "Item Code",
        installation_no: "Item Desc",
        date: `Installed ${typeCostQTY === "cost" ? "Cost" : "Qty"}`,
        install_qty: "Installation Claim",
        installation_claim: "Installation Paid",
        installation_paid: "",
        isHeader: true,
      });

      project?.items?.forEach((item, iIndex) => {
        rows.push({
          project_name: iIndex + 1,
          customer_name: item?.item_code || "N/A",
          installation_no: item?.make_item_description || "N/A",
          date:
            item.is_make_item == true
              ? "-"
              : typeCostQTY == "cost"
              ? item.total_already_installed_cost
              : item?.total_already_installed_qty || "0",
          install_qty:
            item.is_make_item == true
              ? "-"
              : typeCostQTY == "cost"
              ? item.total_installation_claim_cost
              : item?.total_installation_claim || "0",
          installation_claim:
            item.is_make_item == true
              ? "-"
              : typeCostQTY == "cost"
              ? item.total_installation_paid_cost
              : item?.total_installation_paid || "0",
        });

        if (item?.is_make_item == true && item?.buy_items) {
          item?.buy_items?.forEach((buyItem, bIndex) => {
            rows.push({
              project_name: `${iIndex + 1}.${bIndex + 1}`,
              customer_name: buyItem?.item_code || "0",
              installation_no: buyItem?.buy_item_description || "N/A",
              date:
                typeCostQTY == "cost"
                  ? buyItem?.already_installed_cost
                  : buyItem?.already_installed_qty || "0",
              install_qty:
                typeCostQTY == "cost"
                  ? buyItem?.commissioning_claim_cost
                  : buyItem?.commissioning_claim || "0",
              installation_claim:
                typeCostQTY == "cost"
                  ? buyItem?.installation_paid_cost
                  : buyItem?.installation_paid || "0",
            });
          });
        }
      });
    });

    return { columns, rows };
  };

  return (
    <CustomForm
      title={"INSTALLATION REPORT"}
      loadingData={loadingData}
      id={id}
      noBackButton={true}
      noSubmitButton={true}>
      <Row className="mt-1">
        <Col lg={12}>
          <div className="">
            <div className="mb-2 d-flex justify-content-between align-items-center text-white">
              <div>
                <div className="app-search d-flex d-lg-inline mt-0 w-25">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control ps-5"
                      placeholder="Search by project name.."
                      value={searchKeyword}
                      onChange={handleInputChange}
                      style={{
                        width: "15rem",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        borderColor: "#D2D2D2",
                        outline: "none",
                        transition: "all 0.3s ease",
                        boxShadow: "none",
                        marginRight: "0.5rem",
                      }}
                    />
                    <span className="ri-search-line"></span>
                  </div>
                </div>
              </div>
              <div>
                <div onClick={handleExportData} className="btn btn-success">
                  Download CSV
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div
                className=""
                style={{
                  overflowX: "auto",
                  overflowY: "auto",
                  maxHeight: "1000px",
                  width: "100%",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "thin",
                  msOverflowStyle: "none",
                  zIndex: 0,
                }}>
                <table
                  className="table mb-0"
                  style={{
                    border: "1px solid black",
                  }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#8AC1E8",
                      borderBottom: "1px solid #cccccc",
                    }}>
                    <tr>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Sr. No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Project Name
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Customer Name
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Installation No
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Date
                      </th>

                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Installed {typeCostQTY === "cost" ? "Cost" : "Qty"}
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Installation Claim
                      </th>
                      <th
                        style={{
                          whiteSpace: "nowrap",
                        }}>
                        Installation Paid
                      </th>

                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords?.length > 0 ? (
                      currentRecords.map((row, index) => (
                        <React.Fragment key={index}>
                          <tr
                            style={{
                              verticalAlign: "middle",
                            }}
                            onClick={() => toggleCategory(index)}>
                            <td>{index + 1}</td>
                            <td
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                minWidth: "180px",
                              }}>
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 2,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "break-word",
                                }}
                                title={row?.project_name || "N/A"}>
                                {row?.project_name || "N/A"}
                              </div>
                            </td>{" "}
                            <td>{row?.customer_name || "N/A"}</td>
                            {/* <td>{row?.order_no || "N/A"}</td> */}
                            <td>{row?.installation_no || "N/A"}</td>
                            <td
                              style={{
                                width: "150px",
                                minWidth: "150px",
                                maxWidth: "150px",
                              }}>
                              {formatDate(row?.installation_date) || "N/A"}{" "}
                            </td>
                            <td>
                              {" "}
                              {typeCostQTY == "cost"
                                ? row?.total_already_installed_cost
                                : row?.total_already_installed_qty || "0"}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? row?.installation_claim_cost
                                : row?.installation_claim || "0"}
                            </td>
                            <td>
                              {typeCostQTY == "cost"
                                ? row?.total_installation_paid_cost
                                : row?.total_installation_paid || "0"}
                            </td>
                            <td>
                              <i
                                className={`mdi mdi-chevron-${
                                  expandedCategories[index] ? "up" : "down"
                                } font-size-18`}></i>
                            </td>
                          </tr>

                          {expandedCategories[index] && (
                            <>
                              <tr
                                style={{
                                  backgroundColor: "#E5F1FC",
                                  borderBottom: "1px solid #cccccc",
                                }}>
                                <th></th>
                                <th></th>
                                <th style={{ whiteSpace: "nowrap" }}>Sr No</th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Code
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Item Description
                                </th>

                                <th style={{ whiteSpace: "nowrap" }}>
                                  Installed
                                  {typeCostQTY === "cost" ? "Cost" : "Qty"}
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Installation Claim
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}>
                                  Installation Paid
                                </th>
                                <th style={{ whiteSpace: "nowrap" }}></th>
                              </tr>
                              {row.items.map((item, iIndex) => (
                                <React.Fragment key={iIndex}>
                                  <tr
                                    style={{
                                      backgroundColor: "#f2f2f2",
                                    }}>
                                    <td></td>
                                    <td></td>

                                    <td>{iIndex + 1}</td>
                                    <td>{item.item_code}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                        title={
                                          item?.make_item_description || "N/A"
                                        }>
                                        {item?.make_item_description || "N/A"}
                                      </div>
                                    </td>

                                    <td>
                                      {item?.is_make_item == true
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(
                                            item?.total_already_installed_cost
                                          )
                                        : formatNumber(
                                            item?.total_already_installed_qty ||
                                              "0"
                                          )}
                                    </td>
                                    <td>
                                      {item?.is_make_item == true
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(
                                            item.total_installation_claim_cost
                                          )
                                        : formatNumber(
                                            item?.total_installation_claim ||
                                              "0"
                                          )}
                                    </td>
                                    <td>
                                      {item.is_make_item == true
                                        ? "-"
                                        : typeCostQTY == "cost"
                                        ? formatNumber(
                                            item.total_installation_paid_cost
                                          )
                                        : formatNumber(
                                            item?.total_installation_paid || "0"
                                          )}
                                    </td>

                                    <td></td>
                                  </tr>

                                  {item?.buy_items &&
                                    item?.is_make_item == true &&
                                    item?.buy_items?.map(
                                      (buyItem, buyIndex) => (
                                        <tr
                                          key={buyIndex}
                                          style={{
                                            backgroundColor: "#f2f2f2",
                                          }}>
                                          <td></td>
                                          <td></td>

                                          <td
                                            style={{
                                              paddingLeft: "30px",
                                            }}>{`${iIndex + 1}.${
                                            buyIndex + 1
                                          }`}</td>
                                          <td>{buyItem?.item_code}</td>
                                          <td>
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                buyItem?.buy_item_description ||
                                                "N/A"
                                              }>
                                              {buyItem?.buy_item_description ||
                                                "N/A"}
                                            </div>
                                          </td>

                                          <td>
                                            {typeCostQTY == "cost"
                                              ? formatNumber(
                                                  buyItem?.already_installed_cost
                                                )
                                              : formatNumber(
                                                  buyItem?.already_installed_qty ||
                                                    "0"
                                                )}
                                          </td>
                                          <td>
                                            {typeCostQTY == "cost"
                                              ? formatNumber(
                                                  buyItem?.installation_claim_cost
                                                )
                                              : formatNumber(
                                                  buyItem?.installation_claim ||
                                                    "0"
                                                )}{" "}
                                          </td>
                                          <td>
                                            {typeCostQTY == "cost"
                                              ? formatNumber(
                                                  buyItem.installation_paid_cost
                                                )
                                              : formatNumber(
                                                  buyItem?.installation_paid ||
                                                    "0"
                                                )}
                                          </td>

                                          <td></td>
                                        </tr>
                                      )
                                    )}
                                </React.Fragment>
                              ))}
                            </>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No data available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-primary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}>
                  Previous
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-primary"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InstallationReport;
